<div>
    <div class="bottom-right" (click)="clearWords()">reset</div>
</div>